var execv2 = {
    util: {},
    ui: {},
    messages: {},
    files: {},
    actions: {},
    history: {},
    form: {},
    tutorial: {},
    ownership: {}
};

execv2.util.safeGetElementById = function(id) {
    if (document.getElementById(id) !== null)
        return document.getElementById(id);

    return { "value": "", "innerHTML": "" };
}

execv2.objects = {
    codFlowExecute: execv2.util.safeGetElementById("inpCodFlowExecute").value,
    codFlowExecuteUID: execv2.util.safeGetElementById("inpCodFlowExecuteUID").value,
    codFlowExecuteMaster: execv2.util.safeGetElementById("inpCodFlowExecuteMaster").value,
    codFlowExecuteTask: execv2.util.safeGetElementById("inpCodFlowExecuteTask").value,
    codFlowExecuteTaskPosition: execv2.util.safeGetElementById("inpCodFlowExecuteTaskPosition").value,
    codFlowElement: execv2.util.safeGetElementById("inpCodFlowElement").value,
    urlToRedirect: execv2.util.safeGetElementById("inpUrlToRedirect").value,
    hidDsActorName: document.getElementById("inpDsActorName"),
    containerActorAvatar: execv2.util.safeGetElementById("containerActorAvatar").innerHTML,
    codFlow: execv2.util.safeGetElementById("inpCodFlow").value,
    codServiceSafeEnc: execv2.util.safeGetElementById("inpCodServiceSafeEnc").value,
    buttons: document.getElementById("controllers"),
    offsetBottom: document.getElementById("offsetBottom"),
    requestScreen: execv2.util.safeGetElementById("inpCodFlowExecute").value === "",
    isTask: execv2.util.safeGetElementById("inpCodFlowExecute").value !== "",
    isRequest: execv2.util.safeGetElementById("inpCodFlowExecute").value === "",
    inpCodUserForwardTo: document.getElementById("inpCodUserForwardTo"),
}

execv2.services = {
    urlFiles: `${smlbpms.baseUrl}api/internal/bpms/1.0/files`,
    urlMessages: `${smlbpms.baseUrl}api/internal/legacy/1.0/messages`,
    urlHistory: `${smlbpms.baseUrl}api/internal/legacy/1.0/history`,
    urlTutorialGet: `${smlbpms.baseUrl}api/internal/bpms/1.0/tutorial/${execv2.objects.codServiceSafeEnc}/published`,
    urlTutorialLike: `${smlbpms.baseUrl}api/internal/bpms/1.0/tutorial/${execv2.objects.codServiceSafeEnc}/like`,
    urlTutorialDislike: `${smlbpms.baseUrl}api/internal/bpms/1.0/tutorial/${execv2.objects.codServiceSafeEnc}/dislike`,
    urlTaskPositionOtherActions: `${smlbpms.baseUrl}api/internal/legacy/1.0/execute/taskposition.aspx?m=isalreadyowner&t=${execv2.objects.codFlowExecuteTask}`,
    urlTakeback: `${smlbpms.baseUrl}api/internal/legacy/1.0/execute/history.aspx?m=take-back&cfe=${execv2.objects.codFlowExecute}`
}


execv2.util.stripHTML = function (s) {
    s = s.replace(/<\/?[^>]+(>|$)/g, "");
    s = s.replace(/(?:\r\n|\r|\n)/g, '<br>');


    return s;
}

execv2.util.breaklineWithBr = function (s) {
    s = s.replace(/(?:\r\n|\r|\n)/g, '<br>');

    return s;
}

execv2.util.htmlEncode = function (s) {
    return filterXSS(s);
}

execv2.util.removeWhiteSpaces = function (o) {
    var node = null;
    while (node = node ? node.nextSibling : o.firstChild) {
        if (node.nodeType == 3 && !/\S/.test(node.nodeValue)) {
            o.removeChild(node);
        }
    }
    if (node || o.firstChild) {
        while (node = node ? node.nextSibling : o.firstChild.firstChild) {
            if (node.nodeType == 3 && !/\S/.test(node.nodeValue)) {
                o.firstChild.removeChild(node);
            }
        }
    }
}

execv2.util.sanitizeTextToConcat = function (s) {

    s = execv2.util.stripHTML(s);
    s = s.replace(/,/g, '!@!');
    s = s.replace(/;/g, '$@$');
    s = s.replace(/"/g, '\\');
    return s;
}

execv2.util.rewriteConcatToText = function (s) {
    s = s.replace(/!@!/g, ',');
    s = s.replace(/\$@\$/g, ';');
    s = s.replace(/\\/g, '"');

    return s;
}

execv2.util.identifyMention = function (s) {
    s = s.replace(/(@[\S]*)/g, '<b>$1</b>');
    return s;
}

execv2.ui = {

    increaseCounter: function (counter) {
        counter.innerHTML = parseInt(counter.innerHTML) + 1;
    },

    resetCounter: function (counter) {
        counter.innerHTML = 0;
    },

    adjustOffsetBottom: function () {
        if (execv2.objects.offsetBottom!==null)
            execv2.objects.offsetBottom.style.height = (buttons.offsetHeight + 30) + "px";
    },

    adjustLegacyMultivaloredTables: function () {

        var tbls = document.querySelectorAll("[mult='S']");

        h.forEach(tbls, function (i, tbl) {

            var container = document.createElement("div");
            container.className = "table-responsive";

            tbl.parentNode.insertBefore(container, tbl);
            container.appendChild(tbl);


            tbl.className = "table table-striped table-bordered";
            tbl.cellPadding = 0;
            tbl.cellSpacing = 0;
            tbl.border = 0;
            tbl.style.display = "";
            tbl.style.width = "100%";

        });

    }
}


execv2.setUploadCallbacks = function (filepath, querystring, filename, fileresume, requestercansee, associatedfieldname, viewercrypt, rowindex, filetype) {

    if (associatedfieldname) {

        execv2.form.fileUpload.add(filename, filepath, associatedfieldname, viewercrypt, rowindex);

    } else {
        execv2.files.add(filename, filepath, fileresume, querystring, requestercansee, filetype);

    }
    captureModule.capture.load();
}

execv2.showControllerBlock = function () {
    document.querySelector('#controllers > #buttons').style.visibility = '';
}

execv2.hideControllerBlock = function () {
    document.querySelector('#controllers > #buttons').style.visibility = 'hidden';
}

execv2.istaskowned  = function () {
    let shouldCheckOwnerShip = execv2.objects.codFlowExecuteTask !== "" && execv2.objects.codFlowExecuteTask !== "0";

    async function iamtheowner() {
        if (!globalThis.parent.location.pathname.includes('2.0/task')
            && !globalThis.parent.location.pathname.includes('2.0/request')) {
            execv2.stopTaskOwnershipCheck();
            return;
        }
        
        if (!shouldCheckOwnerShip) return;

        const data = await execv2.ownership.iAmTheOwner();
        if (data?.error)
            shouldCheckOwnerShip = false;
        else if (!data?.success)
            globalThis.location.reload();
        else if (!globalThis.finishTask)
            execv2.counttasks();
    }

    iamtheowner();
    globalThis.isTaskOwnedId = globalThis.setInterval(iamtheowner, 10000);
}

execv2.counttasks = function () {
    let shouldCountTasks = true;

    async function countTasksJson() {
        let codFlowExecute = document.querySelector('#inpCodFlowExecuteC')?.value;
        let numberOfTasks = document.querySelector('#inpNumberOfTasks')?.value;

        if (!shouldCountTasks || !codFlowExecute) return;

        const data = await execv2.ownership.countTasks();
        if (data?.error)
            shouldCountTasks = false;
        else if (!data?.success || !numberOfTasks) {
            shouldCountTasks = false;
            return;
        }

        numberOfTasks = Number.parseInt(numberOfTasks, 10);

        if (!Number.isNaN(numberOfTasks) && !Number.isNaN(data.success) &&
            (data.success > numberOfTasks) && !globalThis.finishTask) {
            document.querySelector('#controllers button').style.display = 'none'
            document.querySelector('#controllers a').style.display = 'none'
            document.getElementById('divAnotherTaskWasFinalized').classList.remove('hidden');

            // scroll to top
            window.scrollTo(0, 0);

            // stop querying
            shouldCountTasks = false;
        }
    }

    countTasksJson();
}

execv2.stopTaskOwnershipCheck = function () {
    if (globalThis.isTaskOwnedId) {
        globalThis.clearInterval(globalThis.isTaskOwnedId);
        globalThis.isTaskOwnedId = null;
    }
};

execv2.ownership = window.location.pathname.includes('/task') ? new Ownership() : {};

if (execv2.objects.codFlowExecuteTask && execv2.objects.codFlowExecuteTask !== "0") {
    var rowVersion = document.querySelector('#inpRowVersion');
    if (rowVersion && rowVersion.value) {
        ConcurrencyManager.init(execv2.objects.codFlowExecuteTask, rowVersion.value);
    }
}

execv2.ui.adjustOffsetBottom();
execv2.ui.adjustLegacyMultivaloredTables();
upload_callBack = execv2.setUploadCallbacks;

window.addEventListener('beforeunload', () => {
    execv2.stopTaskOwnershipCheck();
    ConcurrencyManager.stopPolling();
});

